import {getTrackBackground, Range} from "react-range";
import React, {useState} from "react";

const CustomRange = ({title, min, max, step, onChange, initial, format = (v) => v}) => {
    const [currentRange, setCurrentRange] = useState(initial || [min, max])

    const handleChange = (values) => {
        setCurrentRange(values);
        onChange(values)
    }

    return (
        <div className="range">
            <div className="range__header">
                <span>{title}</span>
                <span className="range__value">{format(currentRange[0])} to {format(currentRange[1])}</span>
            </div>
            <Range
                step={step}
                min={min}
                max={max}
                values={currentRange}
                onChange={handleChange}
                renderTrack={({props, children}) => (
                    <div
                        {...props}
                        className="range__track"
                        style={{
                            ...props.style,
                            background: getTrackBackground({
                                values: currentRange,
                                colors: ["#ece3cd", "#5c8b4a", "#ece3cd"],
                                min,
                                max
                            })
                        }}
                    >
                        {children}
                    </div>
                )}
                renderThumb={({props}) => {
                    const {key, ...rest} = props;
                    return <div key={key} {...rest} className="range__thumb" style={{...rest.style}}/>;
                }}
            />
        </div>
    )
}

export default CustomRange;
